import { z } from 'zod';

const envSchema = z.object({
  /** 環境 */
  VITE_APP_ENV: z.enum(['local', 'dev', 'stg', 'prd']),
  /** LIFF ID */
  VITE_LIFF_ID: z.string(),
  /** LINE公式アカウント 友だち追加URL */
  VITE_LINE_ADD_FRIEND_URL: z.string().url(),
  /** APIのベースURL */
  VITE_API_BASE_URL: z.string().url(),
  /** 利用規約のURL */
  VITE_TERMS_URL: z.string().url(),
  /** MSWを有効化するかどうか */
  VITE_API_MOCK: z.enum(['true', 'false']).transform((v) => v === 'true'),
  /** LIFFをモックするかどうか */
  VITE_LIFF_MOCK: z.enum(['true', 'false']).transform((v) => v === 'true'),
  /** ログイン画面に追加表示する注釈 */
  VITE_SYSTEM_ANNOTATION: z.string().optional(),
  /** SAASのトリガーID */
  VITE_SAAS_TRIGGER_ID: z.string(),
  /** SentryのDSN */
  VITE_SENTRY_DSN: z.string(),
  /** Sentryを有効化するかどうか */
  VITE_SENTRY_ENABLED: z.enum(['true', 'false']).transform((v) => v === 'true'),
  /** Sentryのトレースサンプルレート */
  VITE_SENTRY_TRACES_SAMPLE_RATE: z.coerce.number().default(0.1),
  /** Sentryのリプレイセッションサンプルレート */
  VITE_SENTRY_REPLAY_SESSION_SAMPLE_RATE: z.coerce.number().default(0.1),
  /** Sentryのリプレイエラーサンプルレート */
  VITE_SENTRY_REPLAY_ON_ERROR_SAMPLE_RATE: z.coerce.number().default(1.0),
});

export const env = envSchema.parse(import.meta.env);
